export const formatCurrency = (amount: number, currencySymbol = "$", fixed = 2) => {
    if (isNaN(amount)) {
        return `${currencySymbol}0`;
    }
    // Formatear el número con separadores de miles y dos decimales
    // const formattedAmount = amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    // const formattedAmount = amount.toString().replace(/\d(?=(\d{3})+\.)/g, "$&,");
    // const formattedAmount = amount.toFixed(2);
    const formattedAmount = amount
        .toFixed(fixed)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Retornar el string formateado con el símbolo de la moneda
    return `${currencySymbol}${formattedAmount}`;
};

export const formatHours = (hours: number) => {
    const days = Math.floor(hours / 24);
    const hourRemaining = hours - days * 24;

    if (days !== 0) {
        if (days == 1) {
            return `${days} día ${hourRemaining} horas`;
        } else {
            return `${days} días ${hourRemaining} horas`;
        }
    }

    return `${hourRemaining} horas`;
};

export const convertMinutes = (totalMinutes: number) => {
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    return `${days} días, ${hours} horas, ${minutes} minutos`;
};

export const formatYears = (months: number) => {
    const years = Math.floor(months / 12);
    const monthsRemaining = Math.floor(months - years * 12);

    let label = "";
    if (years !== 0) {
        label = years === 0 ? `${years} años` : years === 1 ? `${years} año` : `${years} años`;
        label += monthsRemaining === 0 ? "" : ", ";
        label +=
            monthsRemaining === 0 ? "" : monthsRemaining === 1 ? `${monthsRemaining} mes` : `${monthsRemaining} meses`;
    }

    return label;
};

export const formatYearsV2 = (data: number) => {
    if (data === 0) {
        return "0 años";
    }
    const years = parseInt(data.toString());
    const monthsRemaining = Math.floor((data % 1) * 12);

    return `${years} ${years > 1 ? "años" : years === 0 ? " años" : " año"} ${monthsRemaining} ${
        monthsRemaining > 1 ? "meses" : monthsRemaining === 0 ? "meses" : "mes"
    }`;
};

export const replaceLastComma = (s: string) => {
    const lastIndex = s.lastIndexOf(",");

    if (lastIndex === -1) {
        return s;
    }

    return s.substring(0, lastIndex) + " y " + s.substring(lastIndex + 1);
};

export const removeAccents = (str: string): string => {
    const acentos: Record<string, string> = {
        á: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U",
        ñ: "n",
        Ñ: "N",
        ü: "u",
        Ü: "U",
    };

    return str
        .split("")
        .map((letra) => acentos[letra] || letra)
        .join("");
};

export const toCamelCase = (str: string): string => {
    return str.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
};

export const truncateDecimals = (num: number, decimals: number = 2) => {
    const factor = Math.pow(10, decimals);
    return Math.trunc(num * factor) / factor;
};

export const getMagnitude = (num: number) => {
    const exp = Math.floor(Math.log10(Math.abs(num)));
    if (exp < 3) return "";
    if (exp < 6) return "k";
    if (exp < 9) return "M";
    return "B";
};

export const formatCompactNumber = (num: number, decimals = 2) => {
    const factor = Math.pow(10, decimals);

    if (Math.abs(num) >= 1_000_000_000) {
        return Math.trunc((Math.abs(num) / 1_000_000_000) * factor) / factor; // Billions
    } else if (Math.abs(num) >= 1_000_000) {
        return Math.trunc((Math.abs(num) / 1_000_000) * factor) / factor; // Millions
    } else if (Math.abs(num) >= 1_000) {
        return Math.trunc((Math.abs(num) / 1_000) * factor) / factor; // Thousands
    } else {
        return Math.abs(num).toString(); // Menos de mil
    }
};
